import { GlBadge, GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { numberToHumanSize } from '~/lib/utils/number_utils';
import FileIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/file_icon.vue?vue3';
export default {
    name: 'BlobHeaderFilepath',
    components: {
        FileIcon,
        GlBadge,
        GlLink
    },
    props: {
        blob: {
            type: Object,
            required: true
        },
        showPath: {
            type: Boolean,
            required: false,
            default: true
        },
        showAsLink: {
            type: Boolean,
            required: false,
            default: false
        },
        showBlobSize: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        blobSize () {
            return numberToHumanSize(this.blob.size);
        },
        showLfsBadge () {
            return this.blob.storedExternally && this.blob.externalStorage === 'lfs';
        },
        fileName () {
            if (this.showPath) {
                return this.blob.path;
            }
            return this.blob.name;
        },
        linkHref () {
            return this.showAsLink ? {
                href: this.blob?.webPath
            } : {};
        }
    }
};
